export const routes = {
    Vercel: process.env.REACT_APP_NEWS_API_URL || "https://back-noticias-fisp-4.vercel.app",
    Hostinger: "https://srv452353.hstgr.cloud",
};

export const NEWS_API_BASE = routes.Vercel;
